import { render, staticRenderFns } from "./newAndroidTier.vue?vue&type=template&id=6ed9a8b0&"
import script from "./newAndroidTier.vue?vue&type=script&lang=js&"
export * from "./newAndroidTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports